/**
 * Promoção: qualquer armação no carrinho (com ou sem lente) => adiciona
 * automaticamente 1 unidade do produto "Case Ebenézer Eyewear". Remove o brinde
 * sozinho se não houver mais armação no carrinho.
 *
 * O seletor de quantidade do brinde é ocultado em snippets/line-item.liquid
 * e sections/main-cart.liquid (mesmo product_id usado aqui).
 */
(function () {
  'use strict';

  var GIFT_PRODUCT_ID = 15443109052736;
  var GIFT_VARIANT_ID = 67843237708096;

  // Brinde antigo (ÓCULOS DE SOL GRÁTIS): se ainda estiver em algum carrinho, é removido
  var OLD_GIFT_PRODUCT_ID = 10266045645120;

  // Variantes de lente de grau (mesma lista de sections/main-product.liquid, lf2VariantMap)
  var LENS_VARIANT_IDS = new Set([
    51631390359872, 51511144743232, 51631391080768,
    51896627691840, 51896628609344, 51896631525696,
    51898959036736, 51899040530752, 51899058192704,
    51899082244416, 51899071004992,
    51899119927616, 51899098497344
  ]);

  // Qualquer item que não seja lente nem brinde conta como armação
  function isLens(item) {
    return LENS_VARIANT_IDS.has(item.variant_id) ||
      item.product_type === 'Lentes' ||
      /^(par-de-)?lentes?-/.test(item.handle || '');
  }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function fetchCart() {
    return fetch(root() + 'cart.js').then(function (r) { return r.json(); });
  }

  function addGift() {
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: GIFT_VARIANT_ID,
        quantity: 1,
        properties: { '_brinde': 'Case grátis na compra da armação' }
      })
    });
  }

  function setGiftQuantity(lineKey, quantity) {
    return fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    });
  }

  function notifyCartChanged() {
    if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart') {
      window.location.reload();
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  function evaluate(cart) {
    var giftLine = null, oldGiftLine = null, hasFrame = false;
    cart.items.forEach(function (item) {
      if (item.product_id === GIFT_PRODUCT_ID) { giftLine = item; return; }
      if (item.product_id === OLD_GIFT_PRODUCT_ID) { oldGiftLine = item; return; }
      if (isLens(item)) { return; }
      hasFrame = true;
    });

    if (oldGiftLine) {
      return setGiftQuantity(oldGiftLine.key, 0).then(function (r) { if (r.ok) notifyCartChanged(); });
    }
    if (hasFrame && !giftLine) {
      return addGift().then(function (r) { if (r.ok) notifyCartChanged(); });
    }
    if (!hasFrame && giftLine) {
      return setGiftQuantity(giftLine.key, 0).then(function (r) { if (r.ok) notifyCartChanged(); });
    }
    if (hasFrame && giftLine && giftLine.quantity !== 1) {
      return setGiftQuantity(giftLine.key, 1).then(function (r) { if (r.ok) notifyCartChanged(); });
    }
    return Promise.resolve();
  }

  var queue = Promise.resolve();
  function scheduleSync() {
    queue = queue.then(fetchCart).then(evaluate).catch(function () {});
  }

  document.addEventListener('cart:change', scheduleSync);
  document.addEventListener('cart:refresh', scheduleSync);
  document.addEventListener('cart:open', scheduleSync);

  scheduleSync();
})();
